<div class="pageWrapper">
  <div class="container">
    <div class="table_scroll">
      <ng-container *ngIf="cartItems.length; else cartEmpty">
        <table class="table custom-table" [cellPadding]="0" [cellSpacing]="0">
          <tr>
            <th style="width: 12%">Product Image</th>
            <th style="width: 25%">Product Name</th>
            <th style="width: 10%">Quantity</th>
            <th style="width: 13%">Delivery Date <sup>*</sup></th>
            <th style="width: 10%">
              Upload <br />
              <span class="sub_label"> (Max file size: 100MB) </span>
            </th>
            <th style="width: 29%">Additional requirement</th>
            <th style="width: 5%">Action</th>
          </tr>

          <tr *ngFor="let product of cartItems; trackBy: trackCart">
            <td data-label="Product Image">
              <img
                class="product-image"
                src="{{ product.imageUrl }}"
                alt=""
                srcset=""
              />
            </td>
            <td
              data-label="Product Name:"
              class="product-name"
              (click)="redirectToProduct(product.productId)"
            >
              <span>{{ product?.productName }}</span>
            </td>
            <td class="type-number" data-label="Quantity">
              <div class="quatity_box">
                <button
                  [disabled]="product?.quantity <= 0"
                  class="number minus"
                  (click)="minusQuantity(product.productId)"
                >
                  <lucide-icon
                    name="minus"
                    [size]="18"
                    class="lucid-icon"
                  ></lucide-icon>
                </button>
                <span class="quantity-input"
                  ><input
                    type="number"
                    name=""
                    [value]="product?.quantity"
                    (change)="updateQuantity($event, product.productId)"
                /></span>
                <button
                  class="number plus"
                  (click)="addQuantity(product.productId)"
                >
                  <lucide-icon
                    name="plus"
                    [size]="18"
                    class="lucid-icon"
                  ></lucide-icon>
                </button>
              </div>
              <p *ngIf="cartItemsError.has(product.productId)" class="errorTxt">
                Invalid quantity
              </p>
              <!-- <input type="number" value="{{ product?.quantity }}" (keyup)="updateQuantity($event, product.productId)" /> -->
            </td>
            <td data-label="Delivery Date">
              <input
                type="date"
                [(ngModel)]="product.deliveryDate"
                (change)="getDates($event, product)"
                [min]="expectedDeliveryDate"
              />
            </td>
            <td
              data-label="Upload (Max file size: 100MB)"
              class="upload_custom"
            >
              <ng-container
                *ngTemplateOutlet="
                  fileUploader;
                  context: { $implicit: product }
                "
              ></ng-container>
            </td>
            <td>
              <textarea
                rows="3"
                cols="30"
                class="requirement-text-area"
                placeholder="Additional requirements"
                (change)="updateRequirement($event, product.productId)"
                autofocus
              ></textarea>
            </td>
            <td>
              <a
                class="delete-cart-item"
                (click)="
                  deleteCartItem(product?.productName, product.productId)
                "
                ><lucide-icon
                  class="icon large_device"
                  name="trash-2"
                  [strokeWidth]="1.5"
                ></lucide-icon>
                <lucide-icon
                  class="icon mobile_device"
                  name="CircleX"
                  [strokeWidth]="1.5"
                ></lucide-icon
              ></a>
            </td>
          </tr>
        </table>
      </ng-container>
      <ng-template #cartEmpty>
        <div class="emptyRow one">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="130"
              height="204"
              viewBox="0 0 130 204"
              fill="none"
            >
              <g clip-path="url(#clip0_1393_3822)">
                <path
                  d="M17.6107 15.9403C7.79748 20.1777 0.975927 29.9018 0.838379 41.2187V167.748H39.9452C49.1996 167.748 56.7175 160.248 56.7175 151.013V0.317383L17.6107 15.9403Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M58.5701 4.32363C58.3509 4.32363 20.5637 19.5259 20.5637 19.7491C11.1287 23.8233 4.57368 36.7716 4.44043 47.6549L5.37318 168.946C5.60959 168.843 43.3753 168.612 43.3796 168.341C52.2773 168.341 59.5072 158.106 59.5072 149.223L58.5744 4.31934L58.5701 4.32363Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M60.4211 8.33301C59.9784 8.33301 23.5194 23.1145 23.5194 23.5567C14.4627 27.4678 8.16557 43.6446 8.03662 54.0942L9.90642 170.144C10.3749 169.942 46.7995 169.478 46.8081 168.937C55.3533 168.937 62.291 155.968 62.291 147.441L60.4211 8.3373V8.33301Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M62.2695 12.3389C61.6075 12.3389 26.4724 26.6996 26.4724 27.3608C17.794 31.1087 11.759 50.514 11.6387 60.5257L14.4412 171.338C15.1462 171.033 50.2297 170.337 50.2382 169.526C58.4267 169.526 65.072 153.821 65.072 145.647L62.2695 12.3389Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M64.1234 16.3438C63.238 16.3438 29.4268 30.2838 29.4268 31.1639C21.1223 34.7487 15.3538 57.3825 15.2378 66.9606L18.9774 172.53C19.9144 172.127 53.6568 171.195 53.674 170.113C61.5057 170.113 67.863 151.67 67.863 143.856L64.1234 16.3438Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M65.976 20.3535C64.8713 20.3535 32.3841 33.8685 32.3841 34.9719C24.4578 38.3935 18.9516 64.2515 18.8398 73.396L23.5122 173.728C24.6857 173.221 57.0869 172.062 57.1041 170.706C64.579 170.706 70.6484 149.527 70.6484 142.07L65.976 20.3535Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M67.8291 24.3594C66.5009 24.3594 35.3419 37.4536 35.3419 38.7802C27.7939 42.0388 22.5498 71.1252 22.4424 79.8318L28.0518 174.922C29.4574 174.317 60.5219 172.921 60.539 171.298C67.6572 171.298 73.4385 147.385 73.4385 140.28L67.8291 24.3594Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M69.6817 28.3652C68.1343 28.3652 38.2992 41.0388 38.2992 42.5843C31.1294 45.6797 26.1433 77.9946 26.0444 86.2676L32.5866 176.12C34.2286 175.412 63.9477 173.785 63.9692 171.891C70.7348 171.891 76.2239 145.243 76.2239 138.494L69.6817 28.3695V28.3652Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M71.5323 32.375C69.7613 32.375 41.2501 44.6278 41.2501 46.3923C34.4586 49.3246 29.7347 84.868 29.6401 92.703L37.115 177.313C38.9891 176.502 67.3714 174.643 67.3972 172.479C73.8061 172.479 79.0072 143.097 79.0072 136.704L71.5323 32.375Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M73.382 36.3799C71.3918 36.3799 44.2045 48.2076 44.2045 50.1954C37.787 52.9645 33.3295 91.7364 33.2393 99.1336L41.6512 178.506C43.7617 177.596 70.7986 175.505 70.8287 173.071C76.8809 173.071 81.7939 140.954 81.7939 134.913L73.382 36.3799Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M75.2346 40.3857C73.0209 40.3857 47.1617 51.7928 47.1617 53.9995C41.1225 56.6055 36.9273 98.6015 36.8413 105.569L46.186 179.7C48.5329 178.687 74.2287 176.364 74.2588 173.66C79.9542 173.66 84.5793 138.807 84.5793 133.123L75.2346 40.3857Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M77.0885 44.3965C74.6556 44.3965 50.1161 55.3828 50.1161 57.8127C44.4551 60.2556 40.5221 105.48 40.4404 112.01L50.7222 180.903C53.3012 179.791 77.6559 177.232 77.6946 174.257C83.0332 174.257 87.3703 136.67 87.3703 131.338L77.0885 44.3965Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M78.9411 48.4014C76.289 48.4014 53.0734 58.9669 53.0734 61.6158C47.7907 63.8955 44.1199 112.349 44.0425 118.445L55.257 182.096C58.0724 180.881 81.086 178.095 81.1247 174.845C86.1066 174.845 90.1556 134.519 90.1556 129.547L78.9411 48.4014Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M80.7908 52.4072C77.9152 52.4072 56.0278 62.5521 56.0278 65.4199C51.1233 67.5365 47.7104 119.218 47.6416 124.876L59.7932 183.29C62.8407 181.972 84.5132 178.954 84.5562 175.437C89.1856 175.437 92.9424 132.377 92.9424 127.761L80.7908 52.4115V52.4072Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M82.6414 56.4164C79.5465 56.4164 58.9787 66.1362 58.9787 69.2273C54.4482 71.1807 51.3018 126.086 51.2373 131.311L64.3216 184.483C67.6056 183.066 87.937 179.812 87.9843 176.025C92.2569 176.025 95.7257 130.229 95.7257 125.966L82.6414 56.4121V56.4164Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M84.4945 60.4223C81.1761 60.4223 61.9365 69.7213 61.9365 73.0314C57.7842 74.8217 54.9 132.956 54.8398 137.747L68.8569 185.676C72.373 184.157 91.3633 180.675 91.4149 176.613C95.3307 176.613 98.5115 128.083 98.5115 124.176L84.4945 60.418V60.4223Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M86.3471 64.432C82.8095 64.432 64.8938 73.3104 64.8938 76.8394C61.1198 78.4708 58.4978 139.829 58.4419 144.183L73.396 186.874C77.1485 185.256 94.7977 181.538 94.8493 177.21C98.4084 177.21 101.301 125.945 101.301 122.39L86.3471 64.4277V64.432Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M88.1976 68.4385C84.4365 68.4385 67.8447 76.8961 67.8447 80.6483C64.449 82.1166 62.0892 146.704 62.0376 150.623L77.9245 188.073C81.9091 186.351 98.2172 182.401 98.2774 177.803C101.48 177.803 104.084 123.804 104.084 120.605L88.1976 68.4385Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M90.0507 72.4434C86.0704 72.4434 70.8025 80.4759 70.8025 84.4514C67.785 85.7566 65.6831 153.572 65.6401 157.054L82.464 189.266C86.6851 187.445 101.652 183.259 101.712 178.391C104.562 178.391 106.875 121.656 106.875 118.814L90.0507 72.4477V72.4434Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M91.9024 76.4531C87.6986 76.4531 73.7589 84.065 73.7589 88.2594C71.1154 89.4014 69.28 160.441 69.2456 163.489L87.0023 190.459C91.4554 188.536 105.081 184.122 105.146 178.983C107.639 178.983 109.659 119.514 109.659 117.024L91.9024 76.4531Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M93.7521 80.459C89.3291 80.459 76.7133 87.6501 76.7133 92.0635C74.448 93.0424 72.8748 167.31 72.8447 169.925L91.5384 191.657C96.228 189.631 108.513 184.986 108.577 179.576C110.714 179.576 112.446 117.368 112.446 115.238L93.7521 80.4633V80.459Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M95.6056 84.4648C90.959 84.4648 79.6672 91.2352 79.6672 95.8676C77.7802 96.6833 76.4691 174.18 76.4434 176.357L96.0698 192.847C100.996 190.722 111.935 185.84 112.008 180.16C113.788 180.16 115.232 115.217 115.232 113.444L95.6056 84.4648Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M97.4587 88.4746C92.5929 88.4746 82.6249 94.82 82.6249 99.6799C81.1162 100.332 80.0674 181.057 80.0459 182.796L100.605 194.049C105.763 191.821 115.366 186.712 115.439 180.757C116.862 180.757 118.018 113.079 118.018 111.658L97.4587 88.4746Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M99.3113 92.4795C94.222 92.4795 85.5822 98.4041 85.5822 103.483C84.4517 103.972 83.6651 187.926 83.6479 189.231L105.144 195.242C110.539 192.915 118.8 187.57 118.873 181.349C119.939 181.349 120.808 110.936 120.808 109.871L99.3113 92.4838V92.4795Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M101.162 96.4854C95.8533 96.4854 88.5332 101.989 88.5332 107.287C87.7767 107.613 87.2522 194.791 87.2437 195.663L109.673 196.435C115.299 194.005 122.22 188.429 122.301 181.937C123.015 181.937 123.591 108.79 123.591 108.077L101.162 96.4854Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M103.012 98.2578C97.4838 98.2578 91.4875 103.341 91.4875 108.858C91.1093 109.021 90.8471 199.427 90.8428 199.865L114.209 195.396C120.072 192.863 125.651 187.058 125.733 180.292C126.09 180.292 126.378 104.41 126.378 104.054L103.012 98.2578Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
                <path
                  d="M118.744 193.971C124.839 191.339 129.077 185.299 129.163 178.266V99.6494H104.864C99.1129 99.6494 94.4448 104.308 94.4448 110.048V203.682L118.744 193.975V193.971Z"
                  stroke="#DA2128"
                  stroke-miterlimit="10"
                />
              </g>
              <defs>
                <clipPath id="clip0_1393_3822">
                  <rect
                    width="128.754"
                    height="204"
                    fill="white"
                    transform="translate(0.623047)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="cart-empty"
            >Looks like your cart is empty. Explore our range to get
            started</span
          >
          <span class="continue-to-shop-btn" (click)="continueToShop()"
            >Explore Catalogue</span
          >
        </div>
      </ng-template>
    </div>
  </div>

  <ng-template #fileUploader let-product>
    <div *ngIf="!product?.fileId && !product?.attachment">
      <app-upload-dnd
        (fileUploadEvent)="fileUploadEvent($event, product.productId)"
        [documentInfo]="documentInfo"
        [fileUploadConfig]="fileUploadConfig"
        [resetFileUpload]="resetFileUpload"
        [showDragDrop]="false"
      ></app-upload-dnd>
    </div>
    <div *ngIf="product?.fileId || product?.attachment">
      <div class="single-file flex justify-content-between">
        <div class="fileInfo">
          <lucide-icon
            name="FileText"
            class="icon"
            color="#666"
            [size]="16"
          ></lucide-icon>
          <div class="fileDesc">
            <h4
              class="file-name"
              matTooltip="{{ product?.attachment?.fileName }}"
              matTooltipPosition="left"
            >
              {{ product?.attachment?.fileName }}.
              <span class="name">{{ product?.attachment?.type }}</span>
            </h4>
            <span class="name">{{ product?.attachment?.size }}</span>
          </div>
        </div>
        <span (click)="deleteFileLocal(product)" class="delete-file">
          <lucide-icon
            name="trash-2"
            class="my-icon"
            [size]="18"
            color="#202020"
          ></lucide-icon>
        </span>
      </div>
    </div>
  </ng-template>

  <div class="container">
    <form [formGroup]="createRfq" class="wrappInside">
      <div class="action wrappInside row" *ngIf="cartItems.length">
        <div class="formGroup col-sm-4">
          <label>Project/Reference Name<sup>*</sup></label>
          <mat-form-field appearance="outline">
            <input
              matInput
              formControlName="projectName"
              maxlength="200"
              placeholder="Project Name"
            />
          </mat-form-field>
          <div class="errorTxt">
            <div
              *ngIf="
                createRfq?.get('projectName')?.touched ||
                createRfq?.get('projectName')?.dirty
              "
            >
              <div *ngIf="createRfq?.get('projectName')?.hasError('required')">
                projectName name is required
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="formGroup">
        <span *ngIf="minDate">
          <label>Delivery Date</label>
          {{ minDate | date }}
        </span>
      </div> -->
        <div class="formGroup col-sm-4">
          <label>Delivery Address<sup>*</sup></label>
          <mat-form-field appearance="outline">
            <input
              matInput
              formControlName="address"
              maxlength="200"
              placeholder="Delivery Address"
            />
          </mat-form-field>
          <div class="errorTxt">
            <div
              *ngIf="
                createRfq?.get('address')?.touched ||
                createRfq?.get('address')?.dirty
              "
            >
              <div *ngIf="createRfq?.get('address')?.hasError('required')">
                address name is required
              </div>
            </div>
          </div>
        </div>

        <div class="formGroup col-sm-4">
          <label
            >Payment Terms<sup>*</sup
            ><lucide-icon
              name="info"
              [size]="14"
              matTooltip="Choose the payment term that outlines your payment schedule and conditions for this order during checkout"
              matTooltipPosition="right"
            ></lucide-icon
          ></label>
          <mat-form-field appearance="outline">
            <mat-select
              id="modules_rfq_createrfq_4"
              placeholder="paymentTerm"
              formControlName="paymentTerm"
            >
              <mat-option
                value="{{ item.name }}"
                *ngFor="let item of paymentTermData"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <div class="errorTxt">
            <div
              *ngIf="
                createRfq?.get('paymentTerm')?.touched ||
                createRfq?.get('paymentTerm')?.dirty
              "
            >
              <div *ngIf="createRfq?.get('paymentTerm')?.hasError('required')">
                paymentTerm name is required
              </div>
            </div>
          </div>
        </div>
        <div class="formGroup col-sm-4">
          <label
            >Incoterms<sup>*</sup
            ><lucide-icon
              name="info"
              [size]="14"
              matTooltip="Select the Incoterm that defines your shipping and delivery responsibilities for this order during checkout"
              matTooltipPosition="right"
            ></lucide-icon
          ></label>
          <mat-form-field appearance="outline">
            <mat-select
              id="modules_rfq_createrfq_4"
              placeholder="incoTerm"
              formControlName="incoTerm"
            >
              <mat-option
                value="{{ item.name }}"
                *ngFor="let item of incotermLists"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <div class="errorTxt">
            <div
              *ngIf="
                createRfq?.get('incoTerm')?.touched ||
                createRfq?.get('incoTerm')?.dirty
              "
            >
              <div *ngIf="createRfq?.get('incoTerm')?.hasError('required')">
                incoTerm name is required
              </div>
            </div>
          </div>
        </div>

        <!-- .. -->
        <div class="formGroup col-sm-4">
          <button
            class="btn-custom btn-solid"
            mat-button
            color="primary"
            (click)="submitQuoteAttachmentsAndRFQ()"
            [disabled]="iscreateRfqDisabled()"
          >
            Raise RFQ
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
